import axios from "axios";
import { request } from "@/utils/request";

// 查询小程序观众数据
export function selectMini(data) {
  return request({
    url: `/teaData/registerSelect`,
    method: "post",
    data: { id: 1 },
  });
}

//小程序vip观众
export function selectMiniVip() {
  return request({
    url: `/teaData/vipSelect`,
    method: "post",
    data: { id: 1 },
  });
}

//酒店预订
export function selectBookingHotel() {
  return request({
    url: `/teaData/hotelSelect`,
    method: "post",
    data: { id: 1 },
  });
}

// 删除酒店预订
export function deleteBookingHotel(id) {
  return request({
    url: `/teaData/hotelDelete`,
    method: "post",
    data: { id },
  });
}
//兼职报名
export function selectPtRegister() {
  return request({
    url: `/teaData/singjobSelect`,
    method: "post",
    data: { id: 1 },
  });
}
// 删除兼职报名
export function deletePtRegister(id) {
  return request({
    url: `/teaData/singjobDelete`,
    method: "post",
    data: { id },
  });
}
//展位需求
export function selectBookingBooth() {
  return request({
    url: `/teaData/miniboothSelect`,
    method: "post",
    data: { id: 1 },
  });
}
// 删除展位需求
export function deleteBookingBooth(id) {
  return request({
    url: `/teaData/miniBoothDelete`,
    method: "post",
    data: { id },
  });
}
//兼职需求
export function selectRequestPtStuff() {
  return request({
    url: `/teaData/needjianzhiSelect`,
    method: "post",
    data: { id: 1 },
  });
}
// 删除兼职需求
export function deleteRequestPtStuff(id) {
  return request({
    url: `/teaData/needjianzhiDelete`,
    method: "post",
    data: { id },
  });
}
/* 查询分享记录 */
export function selectShareRecord(data) {
  return request({
    url: `/teaData/selectShareRecord`,
    method: "post",
    data,
  });
}
/* 删除分享记录 */
export function deleteShareRecord(data) {
  return request({
    url: `/teaData/deleteShareRecord`,
    method: "post",
    data,
  });
}
/* 修改礼品领取状态 */
export function setRewardStatus(data) {
  return request({
    url: `/teaData/setRewardStatus`,
    method: "post",
    data,
  });
}
